module.exports = {"content":{},"productInfo":{"code":"{7B75B3E2-3D47-45C1-9550-E6DD40BB9572}","name":"ペルシア語（ファルシ語）　初中級","serialHead":"TSTRJ","courseResourceIDs":[{"levelNo":1,"resourceID":"76d293d4e3d6a0332363efa07c53913ae2ff0073"},{"levelNo":2,"resourceID":"560a5aba6d4e11837095013ee7637650663709d9"},{"levelNo":3,"resourceID":"faf9e6188cd6b25aa9ba7d8eb0b908389ad357bb"}],"language":"fa-IR","challengeCount":21642},"version":"1.1.0"}


//////////////////
// WEBPACK FOOTER
// ./static/data.json
// module id = 207
// module chunks = 1